import {
    DEALER_INFO_RECEIVE,
    DEALER_INFO_ERROR,
    DEALER_INFO_CHANGE_MODE,
    ViewMode,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    list: [],
    mode: ViewMode.List,
    errors: {},
};

export const dealerInfo = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case DEALER_INFO_RECEIVE:
        case DEALER_INFO_CHANGE_MODE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case DEALER_INFO_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
